import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';

import { SAMService } from 'src/app/sam/sam.service';
import { SpeechService } from 'src/app/services/speech.service';
import { SoundService } from 'src/app/services/sound.service';
import { ThemeService, BasePage } from 'ngx-elvis-ds';
import { ModalController } from '@ionic/angular';
import { I18NService } from 'src/app/services/i18n.service';
import { SAMMessage } from 'src/app/sam/interfaces/sam-message';

export class ConfirmDialogCommands {
  public static OPEN = ['YES_OR_NO'];
  public static UPDATE = ['YES_OR_NO_UPDATE'];
  public static CLOSE = ['CLOSE_YN_DIALOG'];
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.page.html',
  styleUrls: ['./confirm-dialog.page.scss'],
})
export class ConfirmDialogPage extends BasePage implements OnDestroy, OnInit {

  @Input() data: any = {};
  @Input() isLocal: boolean;

  constructor(
    private sam: SAMService,
    public themeSvc: ThemeService,
    private modalCtrl: ModalController,
    public i18nSvc: I18NService
  ) {
    super();
  }
  
  ngOnInit() {
    this.subscribeListeners();
  }

  ngOnDestroy() {
    if (this.subscriptions.modalEventsListener) { this.subscriptions.modalEventsListener.unsubscribe(); }
  }

  onCallback(success = false) {
    if (this.isLocal) {
      this.modalCtrl.dismiss(success);
    } else {
      this.sam.onSend({
        Command: 'GENERIC_INPUT',
        Val: (success ? 'YES' : 'NO'),
        parms: { Val: (success ? 'YES' : 'NO') }
      });
    }
  }

  private subscribeListeners() {
    this.subscriptions.modalEventsListener = this.sam.channels.dialogs.subscribe((msg: SAMMessage) => {
      if (ConfirmDialogCommands.UPDATE.includes(msg.Command)) {
        const data: any = <any>msg.parms;

        if (data.Title) {
          this.data.Title = data.Title;
        }
        if (data.Question) {
          this.data.Question = data.Question;
        }
      }
    });
  }
}
